import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReviewerAndEmployee, EmployeeWithBuFragment } from '../../../types'
import { PerInfoBox } from '../../../components/custom_components/InfoBox'
import { PerInfoBoxDivider } from '../../../components/custom_components/InfoBox/InfoBoxDivider'
import { PerInfoBoxNumberElement } from '../../../components/custom_components/InfoBox/InfoBoxNumberElement'
import { PerInfoBoxActionButtonElement } from '../../../components/custom_components/InfoBox/InfoBoxActionButtonElement'
import { InfoBoxTile } from '../../../components/custom_components/InfoBox/InfoBoxTileTemplate/InfoBoxTile'
import { BuReviewerAddModal } from './BuReviewerModal'
import PerFlexRow from '../../../components/custom_components/FlexRow'

interface Props {
  existingRelations: ReviewerAndEmployee[]
  subordinates: EmployeeWithBuFragment[]
  buId: string
  companyId: string
  buName: string
}

export const BuReviewerInfoBox: FC<Props> = ({ existingRelations, subordinates, buId, companyId, buName }) => {
  const { t } = useTranslation()

  const [open, setOpen] = useState(false)

  const totalOfReviewer = new Set(existingRelations.map((er) => er.reviewer.id)).size
  const totalOfEmployees = subordinates.length
  const totalOfEmployeesWithMoreReviewers = Object.values(
    existingRelations.reduce((acc, current) => {
      acc[current.employee.id] = (acc[current.employee.id] || 0) + 1
      return acc
    }, {} as Record<string, number>),
  ).filter((v) => v > 1).length

  const onModalOpen = () => {
    setOpen(true)
  }

  return (
    <>
      <BuReviewerAddModal
        open={open}
        onCancel={() => setOpen(false)}
        subordinates={subordinates}
        existingRelations={existingRelations}
        buId={buId}
        buName={buName}
        companyId={companyId}
      />

      <PerInfoBox>
        <PerFlexRow justify="space-between" width="fullWidth" className="fullHeight">
          <PerFlexRow>
            <InfoBoxTile
              heading={t('companySettingsView.reviewerTab.infoBox.reviewer.heading')}
              contentFlex="fixed"
              headingAlign="center"
              contentAlign="center"
            >
              <PerInfoBoxNumberElement number={totalOfReviewer} />
            </InfoBoxTile>

            <PerInfoBoxDivider />

            <InfoBoxTile heading={t('companySettingsView.reviewerTab.infoBox.employeesWithMoreReviewers.heading')} contentFlex="fixed">
              <PerInfoBoxNumberElement
                number={totalOfEmployeesWithMoreReviewers}
                outOf={totalOfEmployees + ' ' + t('companySettingsView.reviewerTab.infoBox.employeesWithMoreReviewers.employees')}
              />
            </InfoBoxTile>
          </PerFlexRow>

          <PerFlexRow>
            <PerInfoBoxDivider />

            <InfoBoxTile
              heading={t('companySettingsView.reviewerTab.infoBox.add.heading')}
              headingAlign="center"
              contentFlex="fixed"
              contentAlign="center"
            >
              <PerInfoBoxActionButtonElement
                icon="add_stroke"
                color="success"
                tooltip={t('companySettingsView.reviewerTab.infoBox.add.btnTooltip')}
                onClick={() => onModalOpen()}
              />
            </InfoBoxTile>
          </PerFlexRow>
        </PerFlexRow>
      </PerInfoBox>
    </>
  )
}
